export const isValidObject = (object: Record<string, unknown> = {}) =>
  Object.keys(object).length > 0;
